import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getProfile } from "../services/users.ts";
import { ADMIN_ROLE_NAME } from "../utils/roles.ts";
import Forbidden from "../pages/Forbidden.tsx";

type AdminRouteProps = {
  children: React.ReactElement;
};

// Asks the server for the role on every mount instead of trusting localStorage, so editing
// localStorage cannot reveal an admin page. The admin API itself also returns 403.
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("user_id");
  const location = useLocation();
  const [state, setState] = useState<"loading" | "admin" | "forbidden">("loading");

  useEffect(() => {
    if (!token || !userId) return;
    let cancelled = false;
    getProfile(userId)
      .then(({ data }) => {
        if (!cancelled) setState(data.role === ADMIN_ROLE_NAME ? "admin" : "forbidden");
      })
      .catch(() => {
        if (!cancelled) setState("forbidden");
      });
    return () => {
      cancelled = true;
    };
  }, [token, userId]);

  if (!token || !userId) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }
  if (state === "loading") {
    return <div className="min-h-screen flex items-center justify-center text-xl font-body text-gray-500">Loading...</div>;
  }
  if (state === "forbidden") return <Forbidden />;
  return children;
};

export default AdminRoute;
